import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
// import Amplify from '@aws-amplify/core';
// import Auth from '@aws-amplify/auth';
import axios from 'axios';
import Amplify, { Auth } from 'aws-amplify';
import '../../Assets/CSS/window.css';
import Header from '../Commonscreens/Header'
import MainCard from '../Screens/Maincard'
import DigitalCard from '../../Assets/Images/Digital Health Card.png';
import Provider from '../../Assets/Images/Find a Provider.png';
import Document from '../../Assets/Images/Documents@3x.png';
import AgentAddActive from '../../Assets/Images/add_agent_active.svg';
import MultipleAgentActive from '../../Assets/Images/add_multiple_agents_active.svg';
import AuditActive from '../../Assets/Images/audit_log_active.svg';
import EncodeURLActive from '../../Assets/Images/encode_urls_active.svg';
import AgentAddInactive from '../../Assets/Images/add_agent.svg';
import MultipleAgentInactive from '../../Assets/Images/add_multiple_agents.svg';
import AuditInactive from '../../Assets/Images/audit_log.svg';
import ReportInactive from '../../Assets/Images/reports_new.svg';
import ReportActive from '../../Assets/Images/reports_active.svg';
import SearchInactive from '../../Assets/Images/search_user.svg';
import SearchActive from '../../Assets/Images/search_user_active.svg';
import EncodeURLInactive from '../../Assets/Images/encode_urls.svg';
import PaymentInactive from '../../Assets/Images/payments.svg';
import PaymentActive from '../../Assets/Images/payments_active.svg';
import PaidThruReport from '../../Assets/Images/reports.svg';
import PaidThruReportActive from '../../Assets/Images/reports_active.svg';
import SendMailIcon from '../../Assets/Images/mail.svg';
import SendMailActiveIcon from '../../Assets/Images/mail_active.svg';
import CognitoDashboardIcon from '../../Assets/Images/cognito_dashboard.svg';
import CognitoDashboardActiveIcon from '../../Assets/Images/cognito_dashboard_active.svg';
import CognitoSettingIcon from '../../Assets/Images/cognito_settings.svg';
import CognitoSettingActiveIcon from '../../Assets/Images/cognito_settings_active.svg';
import PortalUserIcon from '../../Assets/Images/portal_user_mgmt.svg';
import PortalUserActiveIcon from '../../Assets/Images/portal_user_mgmt_active.svg';
import AutoRetryControlIcon from '../../Assets/Images/Auto-Retry-Control-Icon.svg';
import AutoRetryControlIconActive from '../../Assets/Images/Auto-Retry-Control-Icon-Active.svg';
import AutoRetryControl from './AutoRetryControl';
import Loader from '../authentication/loader';
import { Modules } from '../../App';
import { clearState } from '../../store/slice/notificationSlice';
import { loginWithPromise } from '../../store/slice/authSlice';
import Reports from './Reports';
import ReportsModal from './../Screens/Reports/ReportsModal';

const AUTO_RETRY_CONTROL_MODULE = 'AUTO_RETRY_CONTROL';




// const HomeContainer
class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeModule: Modules.Home,
            menuItems: [
                {
                    name: 'Encode URLs',
                    module: Modules.encodeURL,
                    cardImage: EncodeURLInactive,
                    cardHoverImage: EncodeURLActive,
                    showCard: false
                },
                {
                    name: 'OnBoard Agent',
                    module: Modules.OnBoardAgent,
                    cardImage: AgentAddInactive,
                    cardHoverImage: AgentAddActive,
                    showCard:  true
                },
                {
                    name: 'Audit Logs',
                    module: Modules.AuditLogs,
                    cardImage: AuditInactive,
                    cardHoverImage: AuditActive,
                    showCard: false
                },
                {
                    name: 'Payment',
                    module: Modules.Payment,
                    cardImage: PaymentInactive,
                    cardHoverImage: PaymentActive,
                    showCard: true
                },
                // {
                //     name: 'Paid Thru Defaulters Report',
                //     module: Modules.PaidThruReport,
                //     cardImage: PaidThruReport,
                //     cardHoverImage: PaidThruReportActive,
                //     showCard: true
                // },
                // {
                //     name: 'Members Dashboard',
                //     module: Modules.MemberDashboard,
                //     cardImage: PaidThruReport,
                //     cardHoverImage: PaidThruReportActive
                // },
                // {
                //     name: 'Send Mass Emails',
                //     module: Modules.Notification,
                //     cardImage: SendMailIcon,
                //     cardHoverImage: SendMailActiveIcon,
                //     showCard: sessionStorage.getItem('showEmailAdmin') == 'true'
                // },
                // {
                //     name: 'Cognito Dasboard',
                //     module: Modules.CognitoDashboard,
                //     cardImage: CognitoDashboardIcon,
                //     cardHoverImage: CognitoDashboardActiveIcon,
                //     showCard: true
                // },
                {
                    name: 'Portal User Management',
                    module: Modules.CognitoSetting,
                    cardImage: PortalUserIcon,
                    cardHoverImage: PortalUserActiveIcon,
                    showCard: true
                },
                {
                    name: 'Search Prospects or Manage Prospects',
                    module: Modules.userSearch,
                    cardImage: SearchInactive,
                    cardHoverImage: SearchActive,
                    showCard: true
                },
                {
                    name: 'Operations Report',
                    module: 'REPORTS',
                    cardImage: ReportInactive,
                    cardHoverImage: ReportActive,
                    showCard: true,
                    popup:true
                },
                {
                    name: 'Auto Retry Control',
                    module: AUTO_RETRY_CONTROL_MODULE,
                    cardImage: AutoRetryControlIcon,
                    cardHoverImage: AutoRetryControlIconActive,
                    showCard: false
                },
                // {
                //     name: 'Operations Dashboard',
                //     module: Modules.OperationsDashboard,
                //     cardImage: CognitoDashboardIcon,
                //     cardHoverImage: CognitoDashboardActiveIcon,
                //     showCard: true
                // },
                // {
                //     name: 'Create Channel',
                //     module: Modules.createChannel,
                //     cardImage: AgentAddInactive,
                //     cardHoverImage: AgentAddActive,
                //     showCard: true
                // },
                
            ],
            showLoader: false,
            showReportsPopup: false,
            isAutoRetryModalOpen: false,
            cardsList: [],
            isCardsApiLoaded: false

        }

        this.idleTimer = null

    }

    componentDidMount() {
        this.props.clearState();
        Auth.currentAuthenticatedUser()
            .then((user) => {
                if (user.token) {
                    let data = this.parseJwt(user.token);
                    localStorage.setItem('email', data.email);
                    this.getAdminCards(data.email);
                    if (sessionStorage.getItem('showEmailAdmin') == null) {
                        this.getUserRoles(data.email);
                    }
                } else {
                    localStorage.setItem('email', user.attributes.email);
                    this.getAdminCards(user.attributes.email);
                    if (sessionStorage.getItem('showEmailAdmin') == null) {
                        this.getUserRoles(user.attributes.email);
                    }
                }
            }).catch((err) => {
                console.log(err)
                sessionStorage.setItem('isLogged', false);
                this.appLogout();
            });
    }

    parseJwt = (id_token) => {
        let base64Url = id_token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                })
                .join('')
        );
        let token = JSON.parse(jsonPayload);
        return token;
    };

    getAdminCards = (email) => {
        this.setState({
            showLoader: true
        });

        axios.get(`${process.env.REACT_APP_adminBaseUrl}/admin/cards/${email}/ADMIN/AC`)
            .then((resp) => {
                const response = resp?.data?.response?.cards;

                // Keep current default card access when API has no usable card response.
                if (!response || typeof response !== 'string') {
                    this.setState({
                        showLoader: false,
                        isCardsApiLoaded: true
                    });
                    return;
                }

                const cards = response
                    .split(',')
                    .map((card) => card.trim())
                    .filter((card) => card.length > 0);

                if (cards.length === 0) {
                    this.setState({
                        showLoader: false,
                        isCardsApiLoaded: true
                    });
                    return;
                }

                const cardsSet = new Set(cards.map((card) => card.toLowerCase()));
                const menuItems = this.state.menuItems.map((item) => ({
                    ...item,
                    showCard: cardsSet.has(item.name.toLowerCase())
                }));

                this.setState({
                    cardsList: cards,
                    menuItems,
                    showLoader: false,
                    isCardsApiLoaded: true
                });
            }).catch((err) => {
                console.log(err, 'failed to load admin cards');
                this.setState({
                    showLoader: false,
                    isCardsApiLoaded: true
                });
            });
    }

    getUserRoles = (email) => {
        let request = { "username": email };
        this.setState({
            showLoader: true
        })
        loginWithPromise().then((token) => {
            axios.post(process.env.REACT_APP_csrBaseUrl + 'csrportal/userrole', request, {
                headers: {
                    Authorization: token
                }
            }).then((resp) => {
                console.log(resp.data)
                let roles = resp.data;
                let menuItems = [...this.state.menuItems];
                sessionStorage.setItem('showEmailAdmin', 'false')
                roles.forEach((item) => {
                    if (item.role == "emailadmin") {

                        menuItems.forEach((item) => {
                            if (item.module == Modules.Notification) {
                                item.showCard = true;
                                sessionStorage.setItem('showEmailAdmin', 'true')
                            }
                        });

                    }
                })
                this.setState({
                    menuItems: menuItems,
                    showLoader: false
                })


            }).catch((err) => {
                console.log(err, 'failed to load templates');
                this.setState({
                    showLoader: false
                })
                sessionStorage.setItem('showEmailAdmin', 'false')
            });
        })

    }



    loadComponent = (moduleKey,popup) => {
        console.log('============== loadComponent =====================');
        console.log(moduleKey);
        if(popup){
            if (moduleKey === "REPORTS") {
                    this.setState({ showReportsPopup: true });
                }
        }else{
        if (moduleKey === AUTO_RETRY_CONTROL_MODULE) {
            this.setState({ isAutoRetryModalOpen: true });
            return;
        }
        // this.setState({
        //     activeModule: moduleKey
        // })

        this.props.history.push(moduleKey)
        }
    }

    handleBack = () => {
        this.setState({
            activeModule: Modules.Home
        });
    }

    closeAutoRetryModal = () => {
        this.setState({ isAutoRetryModalOpen: false });
    }



    appLogout = () => {
        Auth.signOut();
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
    }



    render() {
        let currentScreen;


        return (
            <div className="bottommaincontainer_left">
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '25%', flexWrap: 'wrap', minHeight: '40vh' }}>

                    {
                        this.state.isCardsApiLoaded && this.state.menuItems.map((menu, index) => {
                            if (menu.showCard) {
                                return (
                                    <MainCard key={index}
                                        name={menu.name}
                                        loadComponent={this.loadComponent}
                                        cardImage={menu.cardImage}
                                        moduleKey={menu.module}
                                        cardHoverImage={menu.cardHoverImage}
                                        popup={menu.popup} />
                                )
                            } else {
                                return null
                            }

                        })
                    }

                </div>
                {this.state.isAutoRetryModalOpen && (
                    <AutoRetryControl onClose={this.closeAutoRetryModal} />
                )}
                <Loader showLoader={this.state.showLoader} />
                <ReportsModal
                    open={this.state.showReportsPopup}
                    onClose={() => this.setState({ showReportsPopup: false })}
                />
            </div>
        )
    }

}
const mapStateToProps = (state) => {
    return {

    }
};
// export default connect({}, { clearState })(withRouter(Home));
export default withRouter(connect(mapStateToProps, { clearState })(Home));